import { selector } from "./selector";

const gea = 18
const qFree = 16

function showFormErrors(errors) {
    for (let prop in errors) {
        if (prop === 'order_number') $(selector.errorMessage).html(errors[prop]); else $('#' + prop).addClass('is-invalid').next().html(errors[prop]).show();
    }
}

const submitForm = (e) => {
    e.preventDefault();

    const $form = $(e.target);

    let formData = $form.serialize();

    $(selector.invalidFeedback).hide();
    $(selector.isInvalid).removeClass('is-invalid');
    $(selector.preloader).show();

    setTimeout(function () {
        $.ajax({
            async: true,
            url: '/tag-porucivanje-process-form',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response) {
                    $(selector.tagSerialNumber).prop('disabled', true);
                    $(selector.tagVerificationCode).prop('disabled', true);
                    $(selector.phoneNumber).prop('disabled', true);
                    $(selector.signature).val(response.signature);

                    $(document).off('submit', selector.checkoutForm);
                    $form.submit();
                } else {
                    $(selector.preloader).hide();
                    $(selector.errorMessage).show();
                    showFormErrors(response.errors);
                }
            },
            error: function (response) {
                $(selector.preloader).hide();
                $(selector.errorMessage).show();
                const r = $.parseJSON(response.responseText);
                showFormErrors(r.errors);
            }
        });
    }, 750);
}

const toggleCustomerType = function (e) {
    let customerType = parseInt($(e.target).val());

    if (customerType === 1) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').show();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide();
    } else if (customerType === 2 || customerType === 3) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').show();
    } else {
        console.error('Undefined customer type');
    }
}

const toggleTagType = function (e) {
    let tagType = parseInt($(e.target).val());

    $(selector.helperMsg).attr('href', "#collapse_tag_0" + tagType)
    $(selector.tagCollapse).removeClass('show')

}
export { submitForm, toggleCustomerType, toggleTagType };